export const styles = () => ({
  tableCell: {
    width: '100%'
  }
})



// WEBPACK FOOTER //
// ./src/components/Buses/styles.js